export class EquipmentFluidCapacity {
    id!: string
    equipment!: string
    compartment!: string
    fluidSpecification?: string
    viscosityGrade?: string
    capacityGallons?: number
    capacityQuarts?: number
    changeIntervalHours?: number
    miles?: number
    notes?: string
    archived!: boolean
}

export class EquipmentGet {
    id!: string
    equipment!: string
    mainEdgePartNumber?: string
    mainEdgeQuantity?: number
    sideCutPartNumber?: string
    sideCutQuantity?: number
    boltPinPartNumber?: string
    boltPinQuantity?: number
    nutPartNumber?: string
    nutQuantity?: number
    notes?: string
    archived!: boolean
}

export class EquipmentBattery {
    id!: string
    equipment!: string
    batterySizeGroup!: string
    notes?: string
    archived!: boolean
}

export class EquipmentBrakes {
    id!: string
    equipment!: string
    axle1Pads?: string
    axle1DrumRotor?: string
    axle2Pads?: string
    axle2DrumRotor?: string
    axle3Pads?: string
    axle3DrumRotor?: string
    axle4Pads?: string
    axle4DrumRotor?: string
    notes?: string
    archived!: boolean
}

export class EquipmentFilter {
    id!: string
    equipment!: string
    filterType!: string
    quantity?: number
    oemPartNumber?: string
    baldwinPartNumber?: string
    fleetguardPartNumber?: string
    napaPartNumber?: string
    advanceAutoPartNumber?: string
    wheelerPartNumber?: string
    donaldsonPartNumber?: string
    wixPartNumber?: string
    kenworthPartNumber?: string
    notes?: string
    archived!: boolean
}

export const FLUID_COMPARTMENTS = [
    'Engine Oil',
    'Transmission',
    'Differential',
    'Transfer Case',
    'Coolant',
    'Hydraulic Tank',
    'Final Drive',
    'Swing Drive',
    'Fuel',
] as const

export type FluidCompartment = (typeof FLUID_COMPARTMENTS)[number]
